<template>
  <div class="crew-basic-info-card">
    <div class="crew-basic-info-row">
      <div style="width: 70px;">辞令職</div>
      <div>{{ appointmentRoleName }}</div>
    </div>
    <div class="crew-basic-info-row">
      <div style="width: 70px;">社員区分</div>
      <div>{{ employmentStatusLabel || "-" }}</div>
    </div>
    <div class="crew-basic-info-row">
      <div style="width: 70px;">所属会社</div>
      <div>{{ affiliatedCompanyName || "-" }}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  EnterpriseCrewRoleService,
  EnterpriseCrewsService,
} from "../../../services/master";
import {
  getEmploymentStatusLabel,
  isPermanentEmployee,
} from "../../../../../../management/crews/crew-settings/constants/EmploymentStatus.js";

export default {
  props: {
    crew: { type: Object, required: true },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    appointmentRoleName() {
      const appontmentRole = EnterpriseCrewsService.findAppointmentRoleFirst(
        this.crew
      );
      if (!appontmentRole) {
        return "-";
      }

      const appointmentRoleDetail = EnterpriseCrewRoleService.findById(
        appontmentRole.enterprise_crew_role_id
      );
      if (!appointmentRoleDetail) {
        return "-";
      }

      return appointmentRoleDetail.name;
    },
    // affiliated_companiesから最新のエントリ（start_dateが最新）を取得
    latestAffiliatedCompany() {
      if (!this.crew || !Array.isArray(this.crew.affiliated_companies)) {
        return null;
      }
      const sorted = [...this.crew.affiliated_companies].sort((a, b) => {
        const aDate = a.start_date ? new Date(a.start_date) : null;
        const bDate = b.start_date ? new Date(b.start_date) : null;
        if (!aDate && !bDate) return 0;
        if (!aDate) return 1;
        if (!bDate) return -1;
        return bDate - aDate; // 降順（新しい順）
      });
      return sorted[0] || null;
    },
    // 所属企業名を取得
    // 社員区分が「社員」の場合は、userの会社名を返す
    affiliatedCompanyName() {
      const latest = this.latestAffiliatedCompany;
      if (!latest) {
        return "";
      }
      // 社員区分が「社員」の場合は、userの会社名を返す
      if (isPermanentEmployee(latest.status)) {
        return this.user && this.user.name ? this.user.name : "";
      }
      // それ以外の場合は、affiliated_companiesのnameを返す
      return latest.name || "";
    },
    // 社員区分のラベルを取得
    employmentStatusLabel() {
      const latest = this.latestAffiliatedCompany;
      if (!latest || !latest.status) {
        return "";
      }
      return getEmploymentStatusLabel(latest.status);
    },
  },
};
</script>
<style scoped>
.crew-basic-info-card {
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.crew-basic-info-row {
  display: flex;
  height: 32px;
  gap: 16px;
  font-size: 12px;
  font-weight: bold;
}
</style>
